// extracted by mini-css-extract-plugin
export var cruiseCount = "EmotionalLauncherCountdown-module--cruise-count--0c9e5";
export var cruiseCountLabel = "EmotionalLauncherCountdown-module--cruise-count-label--17e24";
export var subtitleContainer = "EmotionalLauncherCountdown-module--subtitle-container--79b98";